import { pathOr, pluck, pipe, propOr, chain, prop, uniq, filter } from 'ramda';

import serviceTypeCodes from 'constants/serviceTypeCodes';
import { CARRIER_CODE } from 'constants/clubEurostar';
import { getNewClassOfService } from 'utils/classOfService';
import { CLASSES_OF_SERVICE_ORDER } from 'constants/classOfService';

export const buildTrain = (segment) => {
  const {
    trainNumber,
    serviceType,
    timing: { date, departs },
    products,
    feeProducts,
    classOfService
  } = segment;

  return {
    trainNumber,
    serviceType,
    date,
    departs,
    inventoryClass: products[0].inventoryClass,
    classOfService,
    products,
    feeProducts
  };
};

export const getExistingTrains = ({ outbound, inbound }) => ({
  outbound: pathOr([], ['activeBookingItems'], outbound).length > 0 ? buildTrain(outbound) : null,
  inbound: pathOr([], ['activeBookingItems'], inbound).length > 0 ? buildTrain(inbound) : null
});

const getProductFamilyFromJourney = ({ products }) => products?.map(({ productFamily }) => productFamily?.familyGroup);

export const getProductFamiliesBeingExchanged = ({ outbound, inbound }) => [
  ...new Set([outbound, inbound].flatMap((leg) => getProductFamilyFromJourney(leg)).filter(Boolean))
];

export const isExchangingOFETrain = ({ outbound, inbound }) =>
  [outbound, inbound].some((journey) => pathOr([], ['activeBookingItems'], journey).some((bookingItem) => bookingItem.isRebookOFEActive));

export const isTryingToDowngrade = (originalSegmentClass, selectedSegmentClass) => {
  const selectedSegments = selectedSegmentClass?.legs?.flatMap((l) => l.classOfService?.code);

  if (originalSegmentClass.length > 0 && selectedSegments?.length > 0) {
    return selectedSegments?.some(
      (selectedClass, index) =>
        CLASSES_OF_SERVICE_ORDER[getNewClassOfService(originalSegmentClass[index])] -
          CLASSES_OF_SERVICE_ORDER[getNewClassOfService(selectedClass)] <
        0
    );
  }

  return false;
};

const getTariffCodeFromJourney = pipe(
  propOr([], 'products'),
  filter((p) => p.cancelled === false),
  chain(prop('tariffDetails')),
  pluck('tariffCode')
);

const getTariffCodeSelectedForExchange = pipe(propOr([], 'bookingItems'), chain(prop('tariffCode')));

export const getTariffCodeBeingExchanged = (direction) => uniq(chain(getTariffCodeFromJourney, [direction]));

export const getTariffCodeSelected = (direction) => uniq(chain(getTariffCodeSelectedForExchange, [direction]));

export const getCarrier = (booking) => {
  const currentService = booking.pendingCancellationLegs[0].serviceType.code;
  const newService = booking.pendingCreationLegs[0].serviceType.code;

  if (serviceTypeCodes.GREENSPEED === currentService || serviceTypeCodes.GREENSPEED === newService) {
    return CARRIER_CODE.RED;
  } else {
    return CARRIER_CODE.BLUE;
  }
};

export const getTravelClass = ({ legs = [] }) => legs?.[0]?.classOfService?.code;

export const getPriorityLeg = (legs) => {
  const priorityLegs = legs.filter((leg) => [serviceTypeCodes.EUROSTAR, serviceTypeCodes.GREENSPEED].includes(leg?.serviceType?.code));

  return priorityLegs.length > 0 ? priorityLegs : legs;
};
